require('babel-polyfill/node_modules/core-js/modules/core.regexp.escape');
module.exports = require('babel-polyfill/node_modules/core-js/modules/_core').RegExp.escape;
